import React from 'react';
import SvgBlackCover from '.';
import SvGBlackBtn from './button';
import './SvGBlackContainer.scss';
import { useDispatch, useSelector } from 'react-redux';
import { setForceMobile } from 'store/actions';

const SvGBlackContainer = () => {
  const dispatch = useDispatch();
  const { isForceMobile } = useSelector((state) => state);
  // const [isOpen, setIsOpen] = useState(false);
  return (
    <div
      className="svg-black-container"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
        zIndex: 1002,
        pointerEvents: 'none',
      }}
    >
      <SvgBlackCover isOpen={isForceMobile} />
      <SvGBlackBtn
        onClick={() => {
          dispatch(setForceMobile(!isForceMobile));
        }}
      />
    </div>
  );
};

export default SvGBlackContainer;
